module.exports = __webpack_public_path__ + "static/media/footer.98645264.svg";